module.exports = __webpack_public_path__ + "img/app-dashboard.1b6036f9.jpg";